import React from 'react'

function Icon({icon}) {
  return (
      <span
        className={`tabclix-icon ${icon}`}
      ></span>
  );
}

export default Icon